import React from "react";
import ListProduct from "../../Hotel/HotelSearch/HotelSearchMobile/ListProduct";
import CabMobileSearch from "./CabMobileSearch";

const CabMobileView = () => {
  return (
    <div id="hotelSearch" className="hotelsearchmobile">
      <ListProduct />
      <CabMobileSearch/>
    </div>
  );
};

export default CabMobileView;